import { render, staticRenderFns } from "./edit-ordermanagement.vue?vue&type=template&id=102a87a2&"
import script from "./edit-ordermanagement.vue?vue&type=script&lang=ts&"
export * from "./edit-ordermanagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-ordermanagement.vue"
export default component.exports